import { SelectController } from './select.controller';
import template from './select.html';

export const selectComponent = {
  name: 'selectComponent',
  restrict: 'E',
  template,
  controller: SelectController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<'
  }
};
